/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     select2 .select2-selection{height:38px!important}[_nghost-%COMP%]     select2 .select2-selection__rendered{line-height:38px!important}[_nghost-%COMP%]     select2 .select2-selection--single{border:1px solid #e2e5ec!important}"];
export { styles as styles };
